import * as React from "react";
import { Switch as ShadcnSwitch } from "../switch";
import { cn } from "@/lib/utils";

export interface SwitchProps extends Omit<
  React.ComponentPropsWithoutRef<typeof ShadcnSwitch>,
  "checked"
> {
  isSelected?: boolean;
  isDisabled?: boolean;
  size?: "sm" | "md" | "lg";
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  classNames?: {
    base?: string;
  };
}

const Switch = React.forwardRef<
  React.ElementRef<typeof ShadcnSwitch>,
  SwitchProps
>(
  (
    {
      isSelected,
      isDisabled,
      disabled,
      size,
      color,
      classNames,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <ShadcnSwitch
        ref={ref}
        checked={isSelected}
        disabled={disabled ?? isDisabled}
        className={cn(classNames?.base, className)}
        {...props}
      />
    );
  }
);
Switch.displayName = "Switch";

export { Switch };
